"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AOFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_10)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_10`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.07996 12H28.92V24H-7.07996V12Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.07996 0H28.92V12H-7.07996V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.2674 9.5158L17.4955 8.91229L16.9762 7.57896L15.6639 8.01405L16.2674 9.5158ZM13.0674 5.58597L13.4534 4.26668L12.113 3.76141L11.5516 5.02457L13.0674 5.58597ZM15.1306 7.21405L15.9867 6.14036L14.9411 5.16492L13.9446 6.11931L15.1306 7.21405ZM16.492 12.0491L17.8604 11.993V10.4983L16.2534 10.5123L16.492 12.0491ZM15.6078 14.7228L16.9271 15.1088L17.4393 13.7754L16.1762 13.214L15.6078 14.7228ZM13.5727 16.9965L14.6183 17.8877L15.6288 16.8772L14.7095 15.8456L13.5727 16.9965ZM10.2744 6.63159L10.9621 8.02808L12.499 8.25966L11.3832 9.34738L11.6358 10.8842L10.2604 10.1544L8.87793 10.8702L9.1446 9.33334L8.03583 8.24562L9.57969 8.02808L10.2744 6.63159Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.52 4.30176L10.3306 5.58597C13.3551 5.81053 15.7341 8.33684 15.7341 11.4175C15.7341 14.6456 13.1165 17.2351 9.88145 17.2702C7.83232 17.2912 6.28145 16.2316 5.17969 14.9053L4.20425 15.7684C5.25689 17.1018 7.06741 18.5684 9.88145 18.5684C13.8323 18.5684 17.0323 15.3684 17.0323 11.4175C17.0393 7.68421 14.1762 4.61755 10.52 4.30176Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.4042 15.6772L12.5762 16.6597C12.5762 16.6597 16.2183 19.3895 16.3376 19.4948C16.4569 19.6 16.7025 19.6351 16.9762 19.3053C17.2358 18.9895 17.1727 18.7369 17.0393 18.6246C16.899 18.5193 13.4042 15.6772 13.4042 15.6772Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.38318 11.0316C6.84283 11.7544 6.85686 12.6526 7.57967 13.2C7.57967 13.2 17.0674 20.3228 17.1867 20.4281C17.306 20.5333 17.5516 20.5684 17.8253 20.2386C18.0849 19.9228 18.0218 19.6702 17.8884 19.5579C17.7551 19.4526 7.38318 11.0316 7.38318 11.0316ZM10.7305 17.986L11.2428 19.2632L12.6112 18.8421L12.2744 17.5018L10.7305 17.986ZM7.89546 17.7263L7.75511 19.0947L9.16564 19.3474L9.48142 18.007L7.89546 17.7263ZM5.3902 16.2386L4.66739 17.4035L5.81827 18.2526L6.69546 17.186L5.3902 16.2386Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_10`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AOFlag };
